<template>

  <data-form
    :entity="formModel"
    :fields="fields"
    @change="onChange"
    @submit="onSubmit"
    :cancel="false"
    v-loading="loading"
  />

</template>

<script>
import { post, get } from 'providers/http'

export default {
  name: 'server-domain-setup',
  data () {
    return {
      loading: false,
      formModel: {
        customize: false,
        serverName: '',
        domainName: '',
        ip: ''
      }
    }
  },
  computed: {
    fields () {
      let fields = {
        'customize': {
          type: 'checkbox'
        },
        'serverName': {
          disabled: !this.formModel.customize,
          type: 'text'
        },
        'domainName': {
          disabled: !this.formModel.customize,
          type: 'text'
        },
        'ip': {
          disabled: !this.formModel.customize,
          type: 'text',
          rules: [{ max: 16 }]
        }
      }

      return fields
    }
  },
  methods: {
    onChange (formModel) {
      this.formModel = formModel
    },
    async onSubmit (formModel) {
      try {
        await post('api/v1/servers/server-domain-setup', formModel)
        this.$emit('next')
      }
      catch (err) {
        console.error(err)
      }
    }
  },
  async beforeMount () {
    const status = await get('api/v1/servers/server-domain-setup')
    this.formModel.serverName = status.serverName
    this.formModel.domainName = status.domainName
    this.formModel.ip = status.ip

    this.loading = false
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// ServerDomainSetup.vue?4f6c6a6c